import {ChangeDetectionStrategy, Component, computed, HostBinding, Input, input} from "@angular/core";
import {EnkelGruppeModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {NgOptimizedImage, NgStyle} from "@angular/common";
import {erIkkeNil, erNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {MatTooltip} from "@angular/material/tooltip";
import {gruppefarge} from "felles-ng2/modell/Gruppefarge";
import {RessursAdresser} from "felles-ng2/tjenester/ressurser/RessursAdresser";

const debug = initDebugger('GruppeLogoKomponent');

export type Stil = 'mini' | 'liten' | 'stor' | 'xstor' | 'xxstor' | '';

/**
 * viser gruppelogo med ramme i gruppens farge.
 */
@Component({
    selector: 'gruppe-logo',
    templateUrl: 'gruppe-logo.html',
    styleUrl: 'gruppe-logo.scss',
    host: {'data-testid': 'gruppe-logo'},
    imports: [
        NgOptimizedImage,
        NgStyle,
        MatTooltip
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GruppeLogoKomponent {

    gruppe = input<EnkelGruppeModell | null>(null);
    logoUrl = input<string | null>(null);
    farge = input<string | null>(null);
    @Input() @HostBinding('class') stil: Stil = '';

    url = computed(() => this.beregnUrl());
    erBlobUrl = computed(() => this.url()?.startsWith('blob:'));
    gruppetittel = computed(() => this.beregnGruppetittel());
    gruppeFarge = computed(() => this.beregnGruppefarge());
    skygge = computed(() => this.beregnSkygg());

    /** dimensjoner for de ulike stilene, må holdes i synk med lederplan-klient/src/scripts/web-ng2/delt/komponenter/avatar/avatar-dimensjoner.scss */
    private størrelser = new Map<Stil, number>([['xxstor', 120], ['xstor', 80], ['stor', 60], ['', 32], ['liten', 28], ['mini', 16]])

    constructor(private ressursAdresser:RessursAdresser) {
    }

    // private hjelpemetoder

    private beregnUrl(): string | null {
        if (erIkkeNil(this.logoUrl())) return this.logoUrl();
        if (erIkkeNil(this.gruppe()?.logoId)) return this.ressursAdresser.gruppelogoUrl(this.gruppe()!, this.gruppelogoStørrelse());
        return null;
    }

    private beregnGruppetittel(): string {
        return erIkkeNil(this.gruppe()) ?
          `${this.gruppe()!.tittel} ${this.gruppe()!.organisasjonsnavn}` :
          '';
    }

    /** Returnerer gruppe-farge, attributtet {@link #farge} har forrang foran {@link #gruppe}. */
    private beregnGruppefarge(): string | null {
        //debug(`beregnGruppefarge, gruppe.farge:${this.gruppe()?.farge}, farge:${this.farge}`);
        if (erIkkeNil(this.farge())) return this.farge()!;
        if (erIkkeNil(this.gruppe())) return gruppefarge(this.gruppe()!).rammeFarge;
        return null;
    }

    /** Returnerer skygge-effekt, attributtet {@link #farge} har forrang foran {@link #gruppe}. */
    private beregnSkygg(): string | null {
        //debug(`beregnSkygg, gruppeFarge:${this.gruppeFarge()}, størrelser:${this.størrelser.get(this.stil)}`);
        if (erNil(this.gruppeFarge())) return null;
        const skyggebredde = (this.gruppelogoStørrelse() / 40) * 1.5;
        return `0 0 ${skyggebredde}px 0 ${this.gruppeFarge()}`;
    }

    private gruppelogoStørrelse(): number {
        return this.størrelser.get(this.stil) ?? 40;
    }
}
